import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { appName } from "../../app.json";
import { useQuery } from "@apollo/react-hooks";
import { LIST } from "../../queries/management-dashboard.query";
import LoadingSpinner from "../../partials/loading";
import AlertMessage from "../../partials/alertMessage";
import { NavLink } from "react-router-dom";
import auth from "../../providers/Auth.Provider";
import { Redirect } from "react-router-dom";
import { toast } from "react-toastify";
import { CleanMessage } from "../../util/app";
import { EVENT_TARGET } from "../../event/model";
import { sendNotification } from "../../sockette";

function Overview({ location }) {
    const title = "Dashboard";
    const [message, setMessage] = useState("");

    const { loading, data, error } = useQuery(LIST, {
        onError: (er) => toast.error(CleanMessage(er.message)),
    });
    if (error && auth.authProvider.IsAuthenticationError(error.message)) {
        auth.authProvider.LogOut();
        return (
            <Redirect
                to={{
                    pathname: "/login",
                    search: `?redirect=${location.pathname}`,
                    state: {
                        from: {
                            pathname: location.pathname,
                        },
                    },
                }}
            />
        );
    }
    return (
        <>
            <Helmet>
                <title>
                    {title} | {appName}
                </title>
            </Helmet>
            <h2>{title}</h2>
            <LoadingSpinner loading={loading} bar={true} />
            <AlertMessage message={error && error.message} failed={true} />
            {!loading && data && (
                <div className="fade-in">
                    <div className="row">
                        <div className="col-12 col-md-8">
                            <div className="row justify-content-center">
                                <NavLink to="/home/app-management/ward" className="col-xl-4 col-md-6 col-12">
                                    <div className="info-box bg-white">
                                        <span className="info-box-icon push-bottom bg-primary">
                                            <i className="material-icons">local_hospital</i>
                                        </span>
                                        <div className="info-box-content m-b-10">
                                            <span className="info-box-text">Total Ward</span>
                                            <span className="info-box-number">{data.CountWard.ward}</span>
                                        </div>
                                    </div>
                                </NavLink>
                                <div className="col-xl-4 col-md-6 col-12">
                                    <div className="info-box bg-white">
                                        <span className="info-box-icon push-bottom bg-warning">
                                            <i className="material-icons">room</i>
                                        </span>
                                        <div className="info-box-content m-b-10">
                                            <span className="info-box-text">Total Rooms</span>
                                            <span className="info-box-number">{data.CountWard.room}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-4 col-md-6 col-12">
                                    <div className="info-box bg-white">
                                        <span className="info-box-icon push-bottom bg-success">
                                            <i className="material-icons">single_bed</i>
                                        </span>
                                        <div className="info-box-content m-b-10">
                                            <span className="info-box-text">Total Beds</span>
                                            <span className="info-box-number">{data.CountWard.bed}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <h3>Top Statistics</h3>
                            <div className="row justify-content-center">
                                <div className="col-xl-4 col-md-6 col-12">
                                    <div className="info-box bg-pink">
                                        <span className="info-box-icon push-bottom bg-transprnt">
                                            <i className="material-icons">home</i>
                                        </span>
                                        <div className="info-box-content">
                                            <span className="info-box-text">Parent Site</span>
                                            <span className="info-box-number">{data.PatientSiteCount.parentSite}</span>
                                            <span className="progress-description">Total site owners</span>
                                        </div>
                                    </div>
                                </div>
                                <NavLink to="/home/app-management/super-admin" className="col-xl-4 col-md-6 col-12">
                                    <div className="info-box bg-white">
                                        <span className="info-box-icon push-bottom bg-info">
                                            <i className="material-icons">verified_user</i>
                                        </span>
                                        <div className="info-box-content m-b-10">
                                            <span className="info-box-text">Super Admin</span>
                                            <span className="info-box-number">{data.TotalSuperAdmin}</span>
                                            <span className="progress-description">Total Super Admin</span>
                                        </div>
                                    </div>
                                </NavLink>
                                <div className="col-xl-4 col-md-6 col-12">
                                    <div className="info-box bg-success">
                                        <span className="info-box-icon push-bottom bg-transprnt">
                                            <i className="material-icons">local_hospital</i>
                                        </span>
                                        <div className="info-box-content">
                                            <span className="info-box-text">Site</span>
                                            <span className="info-box-number">{data.PatientSiteCount.site}</span>
                                            <span className="progress-description">Total number of sites</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-4 p-3">
                            <div className="card">
                                <div className="card-head">
                                    <header>Broadcast Message</header>
                                </div>
                                <div className="card-body min-card">
                                    <form
                                        onSubmit={(evt) => {
                                            evt.preventDefault();
                                            //
                                            if (message) {
                                                sendNotification(message, "CREATE", EVENT_TARGET.Top_Notify);
                                                setMessage("");
                                            }
                                        }}
                                    >
                                        <textarea
                                            name="message"
                                            style={{ fontSize: "1.2em" }}
                                            id="message"
                                            placeholder="Type message here."
                                            className="form-control p-4"
                                            cols="30"
                                            value={message}
                                            onChange={({ currentTarget: { value } }) => setMessage(value)}
                                            rows="10"
                                        ></textarea>
                                        <small>Only online Staff can see this message.</small>
                                        <div className="text-center">
                                            <button type="submit" className="mdl-button mdl-button--raised mdl-js-ripple-effect btn-circle btn-success">
                                                Broadcast
                                                <i className="material-icons">arrow_right_alt</i>
                                            </button>
                                            <button
                                                onClick={() => sendNotification("nothing", "REMOVE", EVENT_TARGET.Clear_Top_Notify)}
                                                type="button"
                                                className="mdl-button mdl-button--raised mdl-js-ripple-effect ml-2 btn-circle btn-default"
                                            >
                                                <i className="material-icons text-danger">clear</i>
                                                Clear Message Area
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>

                    <h3>Financial Statistics</h3>
                    <div className="row justify-content-start">
                        <div className="col-xl-4 col-md-6 col-12">
                            <div className="info-box bg-white">
                                <span className="info-box-icon push-bottom bg-success">
                                    <i className="material-icons">assignment_turned_in</i>
                                </span>
                                <div className="info-box-content m-b-10">
                                    <span className="info-box-text">Active Subscription</span>
                                    <span className="info-box-number">{data.TotalActiveSubscription}</span>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-6 col-12">
                            <div className="info-box bg-white">
                                <span className="info-box-icon push-bottom bg-pink">
                                    <i className="material-icons">remove_shopping_cart</i>
                                </span>
                                <div className="info-box-content m-b-10">
                                    <span className="info-box-text">Expired Subscription</span>
                                    <span className="info-box-number">{data.TotalExpiredSubscription}</span>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-6 col-12">
                            <div className="info-box bg-white">
                                <span className="info-box-icon push-bottom bg-warning">
                                    <i className="material-icons">payment</i>
                                </span>
                                <div className="info-box-content m-b-10">
                                    <span className="info-box-text">Almost Due Subscription</span>
                                    <span className="info-box-number">0</span>
                                </div>
                            </div>
                        </div>
                        {data.AmountEaredByCurrency.map((item, idx) => (
                            <div key={idx} className="col-xl-4 col-md-6 col-12">
                                <div className="info-box bg-white">
                                    <span className="info-box-icon push-bottom bg-success">
                                        <i className="material-icons">monetization_on</i>
                                    </span>
                                    <div className="info-box-content m-b-10">
                                        <span className="info-box-text">
                                            Earning In <strong>{item.currency}</strong>
                                        </span>
                                        <span className="info-box-number">
                                            {item.currency} {Intl.NumberFormat("en-GB").format(item.amount)}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </>
    );
}

export default Overview;
